<div class="row">
  <div class="col-xs-12">
    <app-module-item
      *ngFor="let moduleEl of modules.data;"
      [index]="moduleEl.id"></app-module-item>
  </div>
</div>


